export const routes = {
    requests: "/requests",
    statistic: "/statistic",
    testMessage: "/testMessage",
    bindings: "/bindings"
}
